const iconStroke = '[stroke-linecap:round] [stroke-linejoin:round]'

export function CardCheck() {
  return (
    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-blue-50">
      <svg className={`h-3 w-3 text-[#13479c] ${iconStroke}`} viewBox="0 0 24 24" fill="none" aria-hidden={true}>
        <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.7" />
      </svg>
    </span>
  )
}

export function TableCheck() {
  return (
    <span className="inline-flex h-6 w-6 items-center justify-center rounded-md bg-[#e8f1ff] text-[#13479c]">
      <svg className={`h-3.5 w-3.5 ${iconStroke}`} viewBox="0 0 24 24" fill="none" aria-hidden={true}>
        <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.8" />
      </svg>
    </span>
  )
}

export function TableCross() {
  return (
    <span className="inline-flex h-6 w-6 items-center justify-center text-slate-300">
      <svg className={`h-3.5 w-3.5 ${iconStroke}`} viewBox="0 0 24 24" fill="none" aria-hidden={true}>
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.4" />
      </svg>
    </span>
  )
}

export function WarnIcon() {
  return (
    <svg
      className={`mt-0.5 h-5 w-5 shrink-0 text-amber-500 ${iconStroke}`}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden={true}
    >
      <path
        d="M12 9v4M12 17h.01M10.3 3.9L2.4 17a2 2 0 001.7 3h15.8a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z"
        stroke="currentColor"
        strokeWidth="1.8"
      />
    </svg>
  )
}

export function ChevronDownIcon({ className = '' }: { className?: string }) {
  return (
    <svg className={`h-4 w-4 ${iconStroke} ${className}`} viewBox="0 0 24 24" fill="none" aria-hidden={true}>
      <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.2" />
    </svg>
  )
}

export function AuditIcon() {
  return (
    <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-[18px] bg-[#e8f1ff] text-[#13479c]">
      <svg
        className={`h-7 w-7 ${iconStroke}`}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        aria-hidden={true}
      >
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
        <path d="M8 13h8M8 17h5.5M8 9h2" />
      </svg>
    </span>
  )
}

export function KeyIcon() {
  return (
    <svg className={`mt-0.5 h-4 w-4 shrink-0 text-[#13479c] ${iconStroke}`} viewBox="0 0 24 24" fill="none" aria-hidden={true}>
      <circle cx="7.25" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
      <path d="M11.25 12h10.25M18.4 12v3.4M21.5 12v2.2" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  )
}
